import { errorTypes } from 'catering/constants/errors';

export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_SERVICE = 'online_ordering';
export const KNOWN_ERROR_CODES = [errorTypes.ITEM_NOT_ON_MENU];

export const KNOWN_ERROR_MESSAGES = [
  {
    substring1: 'Catering Location with slug',
    substring2: 'could not be found.'
  },
  {
    substring1: 'Catering Location with slug',
    substring2: 'does not deliver to'
  },
  {
    substring1: 'No fulfillment hours found within 12 months'
  },
  {
    substring1: 'This item is not available at this time.'
  },
  {
    substring1: '"shipping_street_address_1":["This field may not be blank."]'
  },
  {
    substring1: '"shipping_postal_code":["This field may not be blank."]'
  }
];
